module.exports = __webpack_public_path__ + "static/img/B02-辽宁省实验中学1.55812c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/B02-辽宁省实验中学1.png
// module id = BNrL
// module chunks = 0